import React, { useEffect, useState } from 'react';
import axios from 'axios';

const StudentDashboard = () => {
  const [stats, setStats] = useState({
    totalSubjects: 0,
    totalPresents: 0,
    totalAbsents: 0,
  });
  const [recentSessions, setRecentSessions] = useState([]);
  const studentId = localStorage.getItem("userId");

  useEffect(() => {
    if (!studentId) return;
    console.log(stats);
    
    axios.get(`http://localhost:8081/api/student/dashboard-stats/${studentId}`)
      .then(res => {
        console.log(res.data);
         setStats(res.data)
      })
      .catch(err => console.error(err));

    axios.get(`http://localhost:8081/api/student/recent-sessions/${studentId}`)
      .then(res => setRecentSessions(res.data.sessions))
      .catch(err => console.error(err));
  }, [studentId]);

  function formatToDayMonth(dateString) {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
    return `${day} ${month}`;
  }

  return (
    <div className="teacher-dashboard-container">
      <h1 className="dashboard-header">Student Dashboard</h1>

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total Subjects</h3>
          <p>{stats.totalSubjects}</p>
        </div>
        <div className="stat-card">
          <h3>Total Presents</h3>
          <p>{stats.totalPresents}</p>
        </div>
        <div className="stat-card">
          <h3>Total Absents</h3>
          <p>{stats.totalAbsents}</p>
        </div>
      </div>

      <div className="recent-sessions">
        <h2>Recent Attendance</h2>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Subject</th>
              <th>Program</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {recentSessions && recentSessions.map(session => (
              <tr key={session.id}>
                <td>{formatToDayMonth(session.created_at)}</td>
                <td>{session.subject}</td>
                <td>{session.program}</td>
                <td>{session.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentDashboard;
